import React, { useContext, useState, useEffect } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { updateRole, viewRole } from '../Network/Role'
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { setDocumentTitle } from '../AppTitle'

function UpdateRole() {
    const [isLoading, setLoading] = useState(false)
    const { id } = useParams()
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.role
    const [roleName, setRoleName] = useState("")
    const history = useHistory()
    const notify = useContext(NotifyContext)

    const submit = () =>{
        setLoading(true)
        updateRole(id, roleName,
            ()=>{
                setLoading(false)
                notify.showNotify(lang.edit_role_success, lang.edit_role_success_desc, 0)
                history.push("/role")
            },
            (error)=>{
                setLoading(false)
                notify.showNotify("Something wrong", error.message, 2)
            })
    }

    useEffect(() => {
        setDocumentTitle("Edit Role")
        const fetchViewRole = () =>{
            setLoading(true)
            viewRole(id,
                (data)=>{
                    setLoading(false)
                    setRoleName(data.roleName)
                },
                (error)=>{
                    setLoading(false)
                    notify.showNotify("Something wrong", error.message, 2)
                })
        }
        fetchViewRole()
    }, [])

    return (
        <div>
            <HeaderTitle title={lang.edit_role} isShowBack backTo="/role"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        submit()
                    }}>
                        <Form.Group>
                            <Form.Label>{lang.role_name}</Form.Label>
                            <Form.Control
                            value={roleName}
                            onChange={(e)=>setRoleName(e.target.value)}
                            required/>
                        </Form.Group>
                        <hr/>
                        <Button
                        type="submit"
                        >
                            {lang.save_change}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default UpdateRole
